import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import type AjaxFetchService from 'garaje/services/ajax-fetch';
import { type AtlasDisplay, AtlasEditorTab, type AtlasConfig } from 'garaje/utils/atlas';
import urlBuilder from 'garaje/utils/url-builder';
import { TrackedObject } from 'tracked-built-ins';

import type MapsSignageEditController from './controller';

interface RouteParams {
  display_id: string;
}

interface MapsSignageEditRouteModel {
  config: AtlasConfig;
  display: AtlasDisplay;
}

export default class MapsSignageEditRoute extends Route {
  @service declare ajax: AjaxFetchService;
  @service declare store: Store;

  async model({ display_id }: RouteParams): Promise<MapsSignageEditRouteModel> {
    const [config, display] = await Promise.all([
      this.ajax.request<AtlasConfig>(urlBuilder.mapi.devices.deviceConfigUrl(display_id)),
      this.ajax.request<AtlasDisplay>(urlBuilder.mapi.devices.deviceUrl(display_id)),
    ]);

    return {
      config,
      display,
    };
  }

  setupController(
    controller: MapsSignageEditController,
    model: MapsSignageEditRouteModel,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    controller.config = new TrackedObject(model.config as unknown as Record<PropertyKey, unknown>);
    controller.tab = AtlasEditorTab.GENERAL;
  }
}
